export function PayoutPolicyService($http, apexApiUrl) {
    'ngInject'
    return {
        // Division
        retrieveDivisionPayoutPolicies: retrieveDivisionPayoutPolicies,
        retrieveDivisionPayoutPolicy: retrieveDivisionPayoutPolicy,
        updateDivisionPayoutPolicy: updateDivisionPayoutPolicy,
        createDivisionPayoutPolicy: createDivisionPayoutPolicy,
        updatePayoutPolicyCommissions: updatePayoutPolicyCommissions,
        // Corporation
        retrieveIcdCorporationPayoutPolicies: retrieveIcdCorporationPayoutPolicies,
        retrieveIcdCorporationPayoutPolicy: retrieveIcdCorporationPayoutPolicy,
        updateIcdCorporationPayoutPolicy: updateIcdCorporationPayoutPolicy,
        createIcdCorporationPayoutPolicy: createIcdCorporationPayoutPolicy
    };

    function retrieveDivisionPayoutPolicies() {
        return $http({
            method: "GET",
            url: apexApiUrl + "division-payout-policies",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveDivisionPayoutPolicy(divisionID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "division-payout-policies/" + divisionID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateDivisionPayoutPolicy(divisionID, request) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "division-payout-policies/" + divisionID,
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            data: request
        }).then(function (response) {
            return response.data;
        });
    }

    function createDivisionPayoutPolicy(request) {
        return $http({
            method: "POST",
            url: apexApiUrl + "division-payout-policies",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            data: request
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveIcdCorporationPayoutPolicies() {
        return $http({
            method: "GET",
            url: apexApiUrl + "corporation-payout-policies",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function retrieveIcdCorporationPayoutPolicy(icdCorporationID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "corporation-payout-policies/" + icdCorporationID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateIcdCorporationPayoutPolicy(icdCorporationID, request) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "corporation-payout-policies/" + icdCorporationID,
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            data: request
        }).then(function (response) {
            return response.data;
        });
    }

    function createIcdCorporationPayoutPolicy(request) {
        return $http({
            method: "POST",
            url: apexApiUrl + "corporation-payout-policies",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            data: request
        }).then(function (response) {
            return response.data;
        });
    }

    function updatePayoutPolicyCommissions(request) {
        return $http({
            method: "POST",
            url: apexApiUrl + "payout-policy/commissions",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            data: request
        }).then(function (response) {
            return response.data;
        });
    }
}
